import { toast } from '@solinkcorp/solink-components';
import { trackErrorBoundary } from 'src/core/analytics';
import { LONG_NOTIFICATION_DURATION } from 'vd-constants';

export function reportException(params) {
  const {
    error,
    additionalInfo,
    showToast = true,
    showConsole = true,
    sendAnalytics = true,
  } = params;

  //
  // Toast messages
  //
  if (showToast) {
    toast.error(error.message, { autoClose: LONG_NOTIFICATION_DURATION });
  }

  //
  // console
  //
  if (showConsole) {
    console.group(' !!! >>>>>> Exception <<<<<< !!! ');
    console.error(error);
    console.error(additionalInfo);
    console.groupEnd();
  }

  //
  // Mixpanel
  //
  if (sendAnalytics) {
    trackErrorBoundary(error, undefined, additionalInfo);
  }
}
